// Centralised brand constants
export const BRAND = {
    name: "Dr. Erik E. Cárdenas Hernández",
    shortName: "Dr. Erik E. Cárdenas",
    credentials: "YFACS · MASPEN",
    tagline:
        "Cirujano General y Laparoscopista Avanzado · Especialista en Manejo Integral de la Obesidad",
    whatsappNumber: "525562082550",
    whatsappDisplay: "+52 55 6208 2550",
    linktree: "https://linktr.ee/drerikcardenas",
    instagram: "https://www.instagram.com/dr.erikcardenas_cirugia",
    instagramHandle: "@dr.erikcardenas_cirugia",
    facebook: "https://www.facebook.com/share/1CPbPYCQ2V/?mibextid=wwXIfr",
    facebookHandle: "Dr. Erik Cárdenas",
    mendPayUrl:
        "https://mendmx.typeform.com/solicitud1?acquisition_channel=dashboard&merchant_id=2500&utm_campaign=2526",
    // Locally processed logo variants — transparent background, recoloured
    logoGold: "/logo-gold.png",
    logoCream: "/logo-cream.png",
    // Crest-only versions (no baked-in text, ideal for clean wordmark pairing)
    logoMarkGold: "/logo-mark-gold.png",
    logoMarkCream: "/logo-mark-cream.png",
    // Original full crest (with text "Dr. Erik Cárdenas") — only for QR / branding moments
    logoOriginal:
        "https://customer-assets.emergentagent.com/job_cirugia-integral-mx/artifacts/lzta9nxy_IMG_8647.PNG",
    qrLinktree: "/linktree-qr.png",
    headshot:
        "https://customer-assets.emergentagent.com/job_cirugia-integral-mx/artifacts/94rf3shs_IMG_9796.jpg",
};

export const NAV_LINKS = [
    { id: "inicio", label: "Inicio" },
    { id: "quien-soy", label: "Quién soy" },
    { id: "especialidades", label: "Especialidades" },
    { id: "punto-cero", label: "Protocolo Punto Cero" },
    { id: "galeria", label: "Galería" },
    { id: "contacto", label: "Contacto" },
];

export const MOTIVOS = [
    "Manejo Integral de la Obesidad",
    "Laparoscopia Avanzada",
    "Hígado y Vesícula Biliar",
    "Apendicitis / Urgencia Quirúrgica",
    "Hernias",
    "Acalasia / Trastornos Esofágicos",
    "Protocolo Punto Cero",
    "Otro",
];
